export default __webpack_public_path__ + "static/media/3.fddd8f79.jpg";